import React, { isValidElement } from 'react';
import { bool, node, oneOf, oneOfType, string } from 'prop-types';
import { styBtn, styBtnIcon } from './style';

const BTN_VARIANT = [
  'primary',
  'secondary',
  'tertiary',
  'quartenary',
  'danger',
  'topup',
  'grey-outlined',
];

const BTN_SIZE = ['xs', 'sm', 'md'];

const ButtonOldV2 = (props) => {
  const {
    className,
    disabled,
    variant,
    icon,
    iconPosition,
    fluid,
    tooltipTitle,
    children,
    ...rest
  } = props;

  const btnProps = {
    variant,
    fluid,
    iconPosition,
    hadIcon: !!icon,
    ...rest,
  };

  const renderIcon = () => {
    if (isValidElement(icon)) {
      return <span className={styBtnIcon(btnProps)}>{icon}</span>;
    }
    if (typeof icon === 'string') {
      let dataTestId = '';
      if (iconPosition === 'left') {
        dataTestId = 'icoLeft';
      } else if (iconPosition === 'right') {
        dataTestId = 'icoRight';
      }

      return (
        <img
          src={icon}
          alt="ico"
          className={styBtnIcon(btnProps)}
          data-testid={dataTestId}
        />
      );
    }
    return null;
  };

  return (
    <button
      className={`${styBtn(btnProps)} ${className}`}
      {...rest}
      disabled={disabled}
      data-toggle="tooltip"
      data-placement="top"
      title={tooltipTitle}
      type="button"
    >
      {icon && iconPosition === 'left' && renderIcon()}
      {children}
      {icon && iconPosition === 'right' && renderIcon()}
    </button>
  );
};

ButtonOldV2.propTypes = {
  children: oneOfType([node, string]),
  className: string,
  disabled: bool,
  fluid: bool,
  icon: oneOfType([node, string]),
  iconPosition: oneOf(['left', 'right']),
  size: oneOf(BTN_SIZE),
  tooltipTitle: string,
  variant: oneOf(BTN_VARIANT),
};

ButtonOldV2.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  fluid: false,
  icon: '',
  iconPosition: 'left',
  size: 'sm',
  tooltipTitle: '',
  variant: 'primary',
};

export default ButtonOldV2;
